<style lang="scss">
  @use "../../../assets/css/design-system/utils";
  div {
    display: flex;
    flex-direction: column;
    gap: utils.in_rem(8px);
  }
</style>

<script>
  import TinyMCE from "./TinyMCE.svelte";
  import Attachments from "./Attachments.svelte";
  import { fontSize, fontFamily } from "./stores";

  export let value;
  export let attachmentIds;
  export let toolbar = [];

  const customVariables = {
    aiVariables: false,
    spintax: false,
    customVariables: false,
    dateVariables: true,
  };

  const getPlugins = () => {
    const toolbarBtns = toolbar
      .flat()
      .join(" ")
      .split(" ")
      .filter((x) => x !== "|");
    return [
      toolbarBtns.includes("link") && "link",
      "lists",
      "image",
      "table",
      "paste",
      "wordcount", // TODOa
      toolbarBtns.includes("directionalityBtn") && "directionality",
    ]
      .filter(Boolean)
      .join(" ");
  };

  const forcedRootBlockAttrs = {
    style: `margin: 0cm 0cm 0.0001pt; font-family: ${$fontFamily}; font-size: ${$fontSize};`,
  };

  const tableDefaultAttributes = {
    style: `border-collapse: collapse; width:100%; font-family: ${$fontFamily}; font-size: ${$fontSize};`,
    border: 1,
  };

  const toolbarGroups = {
    align: {
      icon: "align-justify",
      tooltip: "Alignment",
      items: "alignleft aligncenter alignright",
    },
  };

  let options = {
    plugins: getPlugins(),
    allow_conditional_comments: true,
    browser_spellcheck: true,
    default_link_target: "_blank",
    image_description: false,
    link_assume_external_targets: "https",
    link_context_toolbar: true,
    link_title: false,
    target_list: false,
    content_css: false,
    skin_url: "/assets/css/design-system/tinymce/rich-text",
    contextmenu: false,
    resize: false,
    toolbar_location: "bottom",
    fontsize_formats: "7.5pt 8pt 9pt 10pt 11pt 12pt 14pt 16pt 18pt 24pt 36pt",
    toolbar,
    toolbar_groups: toolbarGroups,
    menubar: false,
    branding: false,
    statusbar: false,
    height: 300,
    relative_urls: false,
    remove_script_host: false,
    forced_root_block_attrs: forcedRootBlockAttrs,
    table_default_attributes: tableDefaultAttributes,
  };
</script>

<div>
  <TinyMCE
    bind:value
    bind:attachmentIds
    {customVariables}
    {...options}
    class="rich-text"
  />
  <Attachments bind:attachmentIds />
</div>
